import React from 'react';
import { Text, Title, TitleProps } from '@gjensidige/builders-components';

interface SummarySectionProps {
  summary: {
    sectionHeader?: string;
    selections?: {
      label: string;
      value: string;
      noLineBreakOnValue?: boolean;
    }[];
  };
}

export const SummarySection: React.FC<SummarySectionProps> = (
  props: SummarySectionProps
) => {
  return (
    <>
      {props.summary.sectionHeader && (
        <Title as={"h3" as TitleProps['as']} size="body" className="section-header">{props.summary.sectionHeader}</Title>
      )}
      <dl className="summary-section-header">
        {props.summary.selections &&
          props.summary.selections.length > 0 &&
          props.summary.selections.map((selection, index) => {
            if (selection.label && selection.value) {
              return (
                <div className="summary-selections pt-1" key={index}>
                  <dt>
                    <Text size="body" className="summary-label pr-1">{selection.label}</Text>
                  </dt>
                  <dd className="summary-value-wrapper">
                    <Text
                      size="body"
                      className={`summary-value ${
                        selection.noLineBreakOnValue ? 'no-line-break' : ''
                      }`}
                    >
                      {selection.value}
                    </Text>
                  </dd>
                </div>
              );
            }
          })}
      </dl>
    </>
  );
};
